import React, { Component, useMemo, useEffect } from "react";
import DataTable from "../../_Components/DataTable";
import SplitNumber from "../../_Components/SplitNumber";
import { Route, useLocation } from "react-router-dom";
import _ from "lodash";
import { ViewModal } from "./ViewModal";
import { Button } from "react-bootstrap";

function DataGrid({ data, setShowModalReportTransaction, setSelectedReport }) {
  let location = useLocation();

  const columns = useMemo(
    () => [
      {
        accessor: "id",
        Header: "#",
        minWidth: 20,
      },
      {
        accessor: "basketId",
        Header: "شماره سفارش",
        minWidth: "100px",
      },
      {
        accessor: "basketItemPersonId",
        Header: "شماره بلیط",
        minWidth: "100px",
      },
      {
        accessor: "userWalletId",
        Header: "شماره کیف پول",
        minWidth: "100px",
      },
      {
        accessor: "userFullName",
        Header: "نام مشتری",
        minWidth: "100px",
      },
      {
        accessor: "titleS",
        Header: "عنوان",
        minWidth: "100px",
      },
      {
        accessor: "typeS",
        Header: "نوع تراکنش",
        minWidth: "100px",
      },
      // {
      //     Header: "مبدا",
      //     minWidth: 100,
      //     align: "center",
      //     Cell: ({ row }) => (
      //         (row.original.sourceAgency) ?
      //             <div className="text-center success">
      //                 {row.original.sourceAgency?.name}
      //                 -
      //                 {row.original.sourceAccount?.accountNumber}
      //             </div>
      //             :
      //             <div className="text-center success">
      //                 {!_.isEmpty(row.original.sourceTitle) ? row.original.sourceTitle : ""}
      //             </div>
      //     )
      // },
      {
        Header: "مقصد",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center success">
            {!_.isEmpty(row.original.targetTransactionTitle) ? row.original.targetTransactionTitle : ""}
          </div>
        ),
      },
      {
        Header: "مبلغ",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          // row.original.destinationAgencyId === idAgency ?
          //     <div className="text-center success">
          //         <ArrowDownwardIcon />
          //         <SplitNumber number={row.original.amount} />
          //     </div>
          //     :
          //     <div className="text-center danger">
          //         <ArrowUpwardIcon />
          //         <SplitNumber number={row.original.amount} />
          //     </div>
          <div className="text-center success">
            <SplitNumber number={row.original.amount} />
          </div>
        ),
      },
      {
        Header: "تاریخ  تراکنش",
        minWidth: 100,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {_.toString(row.original.completionDate)} - {_.toString(row.original.completionTime)}
          </div>
        ),
      },
      {
        accessor: "createdPersianTime",
        Header: "تاریخ ایجاد",
        minWidth: 90,
        maxWidth: 90,
        align: "center",
      },
      {
        Header: "وضعیت",
        minWidth: 50,
        align: "center",
        Cell: ({ row }) =>
          row.original.isDeleted ? <div className="text-center">حذف شده</div> : <div className="text-center">فعال</div>,
      },
      {
        accessor: "description",
        Header: "توضیحات",
        minWidth: "100px",
      },
      {
        accessor: "strActorType",
        Header: "عامل تراکنش",
        minWidth: 90,
        maxWidth: 90,
        align: "center",
      },
      {
        accessor: "strSupplierSettlementType",
        Header: "نحوه تسویه",
        minWidth: 90,
        maxWidth: 90,
        align: "center",
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* مشاهده  */}
            <Button
              title="مشاهده اطلاعات"
              className="btn btn-light-info btn-sm mr-2 btn-icon"
              onClick={() => {
                setSelectedReport(row.original.id);
                setShowModalReportTransaction(true);
              }}
            >
              <i className="far fa-eye text-small"></i>
            </Button>
            {/* ویرایش  */}
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 50, 100, 500, 1000, 2000],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      {location.pathname === "/reportTransaction/1" && !_.isEmpty(location.state) && _.isNumber(location.state?.id) ? (
        <ViewModal />
      ) : (
        <></>
      )}
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
